module.exports = __webpack_public_path__ + "static/media/track-status.4c1b9b7c.png";